const oss_onboarding = {
    page_title: 'Einführung',
    title: 'Erzähl uns etwas über dich',
    description: 'Erzähl uns etwas über dich und dein Projekt. Das hilft uns, Logto für alle besser zu machen.',
    email: {
        label: 'E-Mail-Adresse',
        description: 'Wir verwenden diese Adresse, wenn wir dich wegen deines Kontos kontaktieren müssen.',
        placeholder: 'email@example.com',
    },
    newsletter: 'Produktupdates, Sicherheitshinweise und ausgewählte Inhalte von Logto erhalten.',
    project: {
        label: 'Ich nutze Logto für',
        personal: 'Persönliches Projekt',
        company: 'Unternehmensprojekt',
    },
    project_name: {
        label: 'Projektname',
        placeholder: 'Mein Projekt',
    },
    company_name: {
        label: 'Firmenname',
        placeholder: 'Acme.co',
    },
    company_size: {
        label: 'Wie groß ist dein Unternehmen?',
    },
    errors: {
        email_required: 'E-Mail-Adresse ist erforderlich',
        email_invalid: 'Gib eine gültige E-Mail-Adresse ein',
        project_name_too_long: 'Der Projektname darf maximal 200 Zeichen lang sein',
    },
};
export default Object.freeze(oss_onboarding);
